module.exports = __webpack_public_path__ + "img/huore.4b24bda5.png";